export const ENTRY = "/";
export const SIGNIN = "/signin";
export const SIGNUP = "/signup";
export const FORGOT_PASSWORD = "/forgot-password";
export const LANDING = "/landing";
export const HOME = "/landing";
export const CAMPAIGN_BREAKDOWN = "/landing/breakdown/:companyId";
export const QR_STATUS = "/status";

export const REWARD = "/rewards";
export const ADMIN_VALIDATION = "/admin-validation";
export const VALIDATION = "/validation";
export const REWARD_DETAILS = "/reward/:id";
export const LEADERBOARD = "/leaderboard";
export const PROFILE = "/profile";
export const PROFILE_EDIT = "/profile/edit";

